import ReactModal from "react-modal";

interface CenterModalProps {
  isOpen: boolean;
  onRequestClose?: () => void;
  children?: any;
  className?: string;
  shouldCloseOnOverlayClick?: boolean;
  contentLabel?: string;
}

const CenterModal: React.FC<CenterModalProps> = ({
  isOpen,
  onRequestClose,
  children,
  className = "",
  contentLabel,
  shouldCloseOnOverlayClick,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={`${className} customScroll outline-none fixed inset-0 m-auto flex flex-col justify-center items-center overflow-hidden rounded-lg bg-white w-[calc(100%-24px)] max-w-[520px] h-auto max-h-[90vh] sm:w-[90%] sm:max-w-[560px] md:w-[75%] lg:w-3/6 lg:max-w-[720px]`}
      overlayClassName="fixed z-20 inset-0 bg-gray-800 bg-opacity-50"
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      contentLabel={contentLabel || "Modal"}
    >
      {children}
    </ReactModal>
  );
};

export default CenterModal;
